var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#62DD90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 33.75C20.0001 35.8125 18.3126 37.5 16.2501 37.5C14.1876 37.5 12.5001 35.8125 12.5001 33.75C12.5001 31.6875 14.1876 30 16.2501 30H17.9168C19.0626 30 20.0001 30.9375 20.0001 32.0833V33.75ZM20.0001 17.9167C20.0001 19.0625 19.0626 20 17.9168 20H16.2501C14.1876 20 12.5001 18.3125 12.5001 16.25C12.5001 14.1875 14.1876 12.5 16.2501 12.5C18.3126 12.5 20.0001 14.1875 20.0001 16.25V17.9167ZM29.4793 27.6042C29.4793 28.625 28.646 29.4792 27.6043 29.4792H22.3751C21.3543 29.4792 20.5001 28.6458 20.5001 27.6042V22.375C20.5001 21.3542 21.3335 20.5 22.3751 20.5H27.6043C28.6251 20.5 29.4793 21.3333 29.4793 22.375V27.6042ZM33.7501 37.5C31.6876 37.5 30.0001 35.8125 30.0001 33.75V32.0833C30.0001 30.9375 30.9376 30 32.0835 30H33.7501C35.8126 30 37.5001 31.6875 37.5001 33.75C37.5001 35.8125 35.8126 37.5 33.7501 37.5ZM33.7501 20H32.0835C30.9376 20 30.0001 19.0625 30.0001 17.9167V16.25C30.0001 14.1875 31.6876 12.5 33.7501 12.5C35.8126 12.5 37.5001 14.1875 37.5001 16.25C37.5001 18.3125 35.8126 20 33.7501 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRef);
export default __webpack_public_path__ + "static/media/icon_ref.1a66c3a16e9b5469fa23c7b69656d631.svg";
export { ForwardRef as ReactComponent };